import { supabase } from "../lib/supabase";

export async function submitRating({
  bookingId,
  ratedUserId,
  ratedRole,
  rating,
  review,
}) {
  const {
    data: { user },
    error: userError,
  } = await supabase.auth.getUser();

  if (userError) throw userError;
  if (!user?.id) throw new Error("Please log in before submitting a rating.");

  const { error } = await supabase.from("ratings").insert({
    booking_id: bookingId,
    rater_user_id: user.id,
    rated_user_id: ratedUserId,
    rated_role: ratedRole,
    rating,
    review,
  });

  if (error) throw error;
}
